import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import * as firebase from 'firebase' // import all functions from Firebase folder
import router from './router/router'
import { store } from './store'
import AlertCmp from './components/Shared components/Alert.vue'
import editContact from './components/Contacts/editContact.vue'

Vue.config.productionTip = false
Vue.component('app-alert', AlertCmp)
Vue.component('editContact', editContact)

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    firebase.initializeApp({
      apiKey: 'AIzaSyBY7fSo0hZEOnN0XaYARIkanEOzUxD7z7c',
      authDomain: 'aegeo-phone-book.firebaseapp.com',
      databaseURL: 'https://aegeo-phone-book.firebaseio.com',
      projectId: 'aegeo-phone-book',
      storageBucket: 'aegeo-phone-book.appspot.com'
    })
    //loads ContactList and Hotels when the App is loaded
    this.$store.dispatch('loadContacts')
    this.$store.dispatch('loadHotels')

    
    // listener to check if the authentication state is changed - Auth Status
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.dispatch('autoSignin', user)
      }
    })
    
  }
}).$mount('#app')
